/** Raised when login credentials are rejected (HTTP 401). */
export class LoginFailedError extends Error {
  constructor(message = "Invalid email or password.") {
    super(message);
    this.name = "LoginFailedError";
  }
}
